Vue.component('admin-settings', {
  data () {
    return {
      setting: null,
    };
  },

  /**
   * The component has been created by Vue.
   */
  created () {
    this.getSettings();

    this.$on('updateSettings', function () {
      this.getSettings();
    });
  },

  methods: {
    getSettings () {
      axios.get('/api/settings/1')
        .then(response => {
          this.setting = response.data.setting;
        });
    },
  }
});
